import { localStorageWrapper } from 'approot/shared/storage';

const CONTENT_NOTIFICATION_SNOOZED_KEY =
  'inq-content-notifications-snoozed-until';
const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;
const SNOOZE_DURATION = TWENTY_FOUR_HOURS_MS;

export const isContentNotificationSnoozed = (): boolean => {
  const snoozedUntil = localStorageWrapper.getItem(
    CONTENT_NOTIFICATION_SNOOZED_KEY
  );
  if (!snoozedUntil) return false;

  return Date.now() < parseInt(snoozedUntil, 10);
};

export const snoozeContentNotification = (): void => {
  const snoozedUntil = Date.now() + SNOOZE_DURATION;
  localStorageWrapper.setItem(
    CONTENT_NOTIFICATION_SNOOZED_KEY,
    snoozedUntil.toString()
  );
};
